export enum FreeShippingBannerType {
	FREE_SHIPPING_INCLUDED = 'FreeShippingIncluded',
	NO_CONTENT = 'NoContent'
}
